// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings Modal Styles */

.settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  backdrop-filter: blur(2px);
}

.settings-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 90vw;
  max-width: 1000px;
  height: 80vh;
  max-height: 600px;
  position: relative;
  overflow: hidden;
  font-family: 'Roboto', sans-serif;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.settings-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: white;
}

.settings-modal-header-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  background: white;
  position: relative;
  flex-shrink: 0;
}

.settings-modal-header-centered h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.settings-modal-header-centered .settings-modal-close {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
}

.settings-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.settings-modal-close {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-modal-close:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.settings-modal-close ion-icon {
  font-size: 1.25rem;
}

.back-button {
  background: none !important;
  border: none !important;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-button:hover {
  background-color: transparent !important;
}
.back-button ion-icon {
  font-size: 1.5rem;
}

.settings-modal-content {
  padding: 24px;
  flex: 1;
  overflow-y: auto;
}

.settings-scrollable-content {
  padding: 24px;
  flex: 1 1 auto;
  overflow-y: scroll;
  min-height: 0;
  max-height: 100%;
}
.settings-page {
  display: none;
  height: 100%;
  width: 100%;
}

.settings-page.active {
  display: block;
}


.settings-content-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
}

/* Left Profile Section */
.settings-profile-section {
  flex: 0 0 25%;
  background-color: rgb(74, 74, 74);
  padding: 24px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-image-container {
  margin-bottom: 16px;
}

.change-avatar-badge {
  position: absolute;
  bottom: 5px;
  right: 0;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.profile-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #6b7280;
  cursor: pointer;
}

.profile-name {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 24px;
  text-align: center;
}

.profile-form {
  width: 100%;
  max-width: 300px;
  margin-bottom: auto;
}

.profile-logout {
  margin-top: auto;
  width: 100%;
  max-width: 300px;
}

.logout-button {
  width: 100%;
  background-color: var(--netsfere-red);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.logout-button:hover {
  background-color: rgb(195, 60, 75);
}

.logout-button ion-icon {
  font-size: 1rem;
}

.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 16px;
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #6b7280;
  border-radius: 6px;
  background-color: #4b5563;
  color: white;
  font-size: 0.875rem;
  box-sizing: border-box;
  cursor: text;
  user-select: text;
}

.form-input[readonly] {
  background-color: #374151;
  cursor: default;
  border-color: #4b5563;
}

.form-input[readonly]:focus {
  outline: none;
  border-color: #6b7280;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
}

/* Right Settings Panel */
.settings-right-panel {
  flex: 1 1 75%;
  display: flex;
  flex-direction: column;
  background: white;
  min-width: 0;
  min-height: 0;
}

/* Right Settings Section */
.settings-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.settings-section {
  padding-bottom: 16px;
}

.settings-section:last-child {
  padding-bottom: 0;
}

.settings-section-header {
  margin: 0 0 8px 0;
  padding-bottom: 8px;
  font-size: 16px;
  border-bottom: 2px solid rgb(200, 200, 200);
}

.settings-header-divider {
  border: none;
  height: 1px;
  background-color: var(--netsfere-red);
  margin: 8px 0 16px 0;
}

.settings-section-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings-line {
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 4px 0;
  display: flex;
  gap: 8px;
}

.settings-label {
  font-weight: 500;
  color: #374151;
}

.settings-value {
  color: #6b7280;
}

.settings-line-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 8px; /* A bit thicker */
  margin: 4px 0;
  box-sizing: border-box;
  background-color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  color: rgb(51, 51, 51);
  font-family: 'Roboto', sans-serif;
  transition: background-color 0.1s ease-in-out;
}


.settings-line-button ion-icon {
  font-size: 1.2rem; /* Bigger */
  --ionicon-stroke-width: 48px; /* Thicker */
  color: #9ca3af; /* A slightly muted grey */
}


.settings-line-button:hover {
  background-color: #f9fafb; /* Very light grey on hover */
}

.settings-line-button:active {
  background-color: #f0f0f0; /* Grey flash on click */
}

.settings-placeholder {
  text-align: center;
  color: #6b7280;
  padding: 40px 20px;
}

.settings-placeholder p {
  margin: 0 0 16px 0;
  line-height: 1.5;
}

.settings-modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
}

.settings-modal-button {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
  font-size: 0.875rem;
}

.settings-modal-button.secondary {
  background-color: white;
  color: #374151;
  border-color: #d1d5db;
}

.settings-modal-button.secondary:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.settings-modal-button.primary {
  background-color: #3b82f6;
  color: white;
}

.settings-modal-button.primary:hover {
  background-color: #2563eb;
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .settings-modal {
    width: 95vw;
    margin: 20px;
  }
  
  .settings-modal-header,
  .settings-modal-content,
  .settings-modal-footer {
    padding-left: 16px;
    padding-right: 16px;
  }
  
  .settings-content-wrapper {
    flex-direction: column;
    gap: 16px;
  }
  
  .settings-profile-section {
    flex: none;
  }
  
  .settings-modal-footer {
    flex-direction: column;
  }
  
  .settings-modal-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/SettingsModal.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB,EAAE,kBAAkB;EACrC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,6CAA6C;AAC/C;;;AAGA;EACE,iBAAiB,EAAE,WAAW;EAC9B,4BAA4B,EAAE,YAAY;EAC1C,cAAc,EAAE,0BAA0B;AAC5C;;;AAGA;EACE,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Settings Modal Styles */\n\n.settings-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n  backdrop-filter: blur(2px);\n}\n\n.settings-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  width: 90vw;\n  max-width: 1000px;\n  height: 80vh;\n  max-height: 600px;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Roboto', sans-serif;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.settings-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  background: white;\n}\n\n.settings-modal-header-centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 24px;\n  background: white;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.settings-modal-header-centered h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.settings-modal-header-centered .settings-modal-close {\n  position: absolute;\n  right: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.settings-modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.settings-modal-close {\n  background: none;\n  border: none;\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.settings-modal-close:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.settings-modal-close ion-icon {\n  font-size: 1.25rem;\n}\n\n.back-button {\n  background: none !important;\n  border: none !important;\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.back-button:hover {\n  background-color: transparent !important;\n}\n.back-button ion-icon {\n  font-size: 1.5rem;\n}\n\n.settings-modal-content {\n  padding: 24px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.settings-scrollable-content {\n  padding: 24px;\n  flex: 1 1 auto;\n  overflow-y: scroll;\n  min-height: 0;\n  max-height: 100%;\n}\n.settings-page {\n  display: none;\n  height: 100%;\n  width: 100%;\n}\n\n.settings-page.active {\n  display: block;\n}\n\n\n.settings-content-wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n/* Left Profile Section */\n.settings-profile-section {\n  flex: 0 0 25%;\n  background-color: rgb(74, 74, 74);\n  padding: 24px;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.profile-image-container {\n  margin-bottom: 16px;\n}\n\n.change-avatar-badge {\n  position: absolute;\n  bottom: 5px;\n  right: 0;\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n\n.profile-image {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #6b7280;\n  cursor: pointer;\n}\n\n.profile-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.profile-form {\n  width: 100%;\n  max-width: 300px;\n  margin-bottom: auto;\n}\n\n.profile-logout {\n  margin-top: auto;\n  width: 100%;\n  max-width: 300px;\n}\n\n.logout-button {\n  width: 100%;\n  background-color: var(--netsfere-red);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 12px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.logout-button:hover {\n  background-color: rgb(195, 60, 75);\n}\n\n.logout-button ion-icon {\n  font-size: 1rem;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-label {\n  display: block;\n  font-size: 16px;\n  margin-bottom: 6px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #6b7280;\n  border-radius: 6px;\n  background-color: #4b5563;\n  color: white;\n  font-size: 0.875rem;\n  box-sizing: border-box;\n  cursor: text;\n  user-select: text;\n}\n\n.form-input[readonly] {\n  background-color: #374151;\n  cursor: default;\n  border-color: #4b5563;\n}\n\n.form-input[readonly]:focus {\n  outline: none;\n  border-color: #6b7280;\n  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);\n}\n\n/* Right Settings Panel */\n.settings-right-panel {\n  flex: 1 1 75%;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  min-width: 0;\n  min-height: 0;\n}\n\n/* Right Settings Section */\n.settings-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.settings-section {\n  padding-bottom: 16px;\n}\n\n.settings-section:last-child {\n  padding-bottom: 0;\n}\n\n.settings-section-header {\n  margin: 0 0 8px 0;\n  padding-bottom: 8px;\n  font-size: 16px;\n  border-bottom: 2px solid rgb(200, 200, 200);\n}\n\n.settings-header-divider {\n  border: none;\n  height: 1px;\n  background-color: var(--netsfere-red);\n  margin: 8px 0 16px 0;\n}\n\n.settings-section-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.settings-line {\n  color: #6b7280;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  padding: 4px 0;\n  display: flex;\n  gap: 8px;\n}\n\n.settings-label {\n  font-weight: 500;\n  color: #374151;\n}\n\n.settings-value {\n  color: #6b7280;\n}\n\n.settings-line-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 12px 8px; /* A bit thicker */\n  margin: 4px 0;\n  box-sizing: border-box;\n  background-color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  font-size: 16px;\n  color: rgb(51, 51, 51);\n  font-family: 'Roboto', sans-serif;\n  transition: background-color 0.1s ease-in-out;\n}\n\n\n.settings-line-button ion-icon {\n  font-size: 1.2rem; /* Bigger */\n  --ionicon-stroke-width: 48px; /* Thicker */\n  color: #9ca3af; /* A slightly muted grey */\n}\n\n\n.settings-line-button:hover {\n  background-color: #f9fafb; /* Very light grey on hover */\n}\n\n.settings-line-button:active {\n  background-color: #f0f0f0; /* Grey flash on click */\n}\n\n.settings-placeholder {\n  text-align: center;\n  color: #6b7280;\n  padding: 40px 20px;\n}\n\n.settings-placeholder p {\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n}\n\n.settings-modal-footer {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 20px 24px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n  border-radius: 0 0 12px 12px;\n  flex-shrink: 0;\n}\n\n.settings-modal-button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n  font-size: 0.875rem;\n}\n\n.settings-modal-button.secondary {\n  background-color: white;\n  color: #374151;\n  border-color: #d1d5db;\n}\n\n.settings-modal-button.secondary:hover {\n  background-color: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.settings-modal-button.primary {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.settings-modal-button.primary:hover {\n  background-color: #2563eb;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .settings-modal {\n    width: 95vw;\n    margin: 20px;\n  }\n  \n  .settings-modal-header,\n  .settings-modal-content,\n  .settings-modal-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  \n  .settings-content-wrapper {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .settings-profile-section {\n    flex: none;\n  }\n  \n  .settings-modal-footer {\n    flex-direction: column;\n  }\n  \n  .settings-modal-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
